<!--登录页面 组件-->
<template>
  <div class="v-login-comment" v-loading="loading">
    <div class="v-login-title">{{ $t('registerLogin') }}</div>
    <div class="v-login-toggle flex-start">
      <!-- TODO: v-if="subjectType == 'ACTOR'" -->
      <template v-if="subjectType == 'ACTOR'">
        <div :class="[isPassLogin ? 'active' : '', 'pointer']" @click="isPassLoginClick(true)">
          {{ $t('passLogin') }}
        </div>
        <div :class="[!isPassLogin ? 'active' : '', 'pointer']" @click="isPassLoginClick(false)">
          {{ $t('codeLogin') }}
        </div>
      </template>
      <template v-else>
        <div class="active pointer">
          {{ language == 'en' ? $t('passLogin') : $t('codeLogin') }}
        </div>
      </template>
    </div>
    <el-form action="" @keyup.enter.native="regLoginMess">
      <div class="v-pass-login-module" v-show="isPassLogin">
        <v-input :labelName="$t('email')" v-model="inputVal.email" @blur="actorLoginCheck"></v-input>
        <v-input type="password" :labelName="$t('password')" v-model="inputVal.password"></v-input>
      </div>
      <div class="v-code-login-module" v-show="!isPassLogin">
        <div class="font-size-14 label" style="line-height: 20px">
          <span class="v-label-color">{{ $t('phone') }}</span>
        </div>
        <el-input
          class="input-with-select"
          maxlength="11"
          v-model="inputVal.phone"
          :placeholder="$t('Please enter your moblie')"
          @blur="actorLoginCheck">
          <span slot="prepend">+{{inputVal.countryCode}}</span>
          <!-- TODO: <el-select v-model="inputVal.countryCode" slot="prepend" filterable :filter-method="filterCountry" @change="resetCountry">
            <el-option v-for="item in countryCodes" :key="item.en" :value="item.prefix" class="v-select-option">
              <span class="code-left">{{ item.prefix }}</span>
              <span class="code-right">{{ language === 'zh' ? item.cn : item.en }}</span>
            </el-option>
          </el-select> -->
        </el-input>
        <v-codes
          v-if="loginType"
          :labelName="$t('code')"
          v-model="inputVal.code"
          @callback="(res) => {callback(res, true)}"
          :regText="inputVal.phone"></v-codes>
        <v-input v-else type="password" :labelName="$t('password')" v-model="inputVal.password"></v-input>
      </div>
      <div class="v-login-flex">
        <!-- 切换密码/验证码 -->
        <div>
          <template v-if="!isPassLogin">
            <div v-if="loginType && subjectType == 'ACTOR'" class="active pointer font-size-12" @click="loginType = false">
              {{ $t('passwordLogin') }}
            </div>
            <div v-else-if="!loginType" class="active pointer font-size-12" @click="loginType = true">
              {{ $t('smsCodeLogin') }}
            </div>
          </template>
        </div>
        <!-- 忘记密码 -->
        <div class="text-right forgetPassword">
          <span class="theme-color pointer font-size-12"
            @click="() => { goResetPass()}">{{ $t('forgetPassword') }}</span>
        </div>
      </div>
      <div v-if="subjectType == 'ACTOR'">
        <p class="font-size-12 p-t-16">{{ $t('actorLoginTips') }}</p>
      </div>

      <el-button type="primary" class="v-big-btn" :loading="loginStatus" @click="regLoginMess">{{ language === 'zh' ? $t('loginRegister') : 'Login' }}</el-button>
      <!-- <el-button type="primary" v-if="subjectType == 'ACTOR'" plain class="v-big-btn el-button--primary-empty" @click="regLoginMess" style="margin-top: 0; padding-top: 11px; padding-bottom: 11px">{{ $t('register') }}</el-button> -->
    </el-form>
    <div class="font-size-12 v-clearfix" v-if="subjectType == 'VISITOR'">
      <label class="pointer" v-if="language === 'en'" @click="() => goResetPass()">{{ $t('login2s.noAccount[0]') }} {{ $t('login2s.register[0]') }}</label>
      <!-- <span @click="registerEvent()" class="text_regi">{{ $t('login2s.register[0]') }}</span> -->
      <TouristChat style="float: right;" v-if="false" />
    </div>
    <div class="no-account2">
      <span>{{ $t('You sign up and agree') }}</span>
      <span class="theme-color pointer">
          <a href="javascript:void(0)"  @click="agreement">{{ $t('Privacy agreement') }}</a>
      </span>
    </div>
    <div class="other-login" v-if="subjectType == 'VISITOR' && $config.settings.thirdPartyLogin">
      <label>{{ $t('login2s.anotherAccount') }}</label>
      <div>
        <img :src="face" @click="otherLogin('facebook')" />
        <img :src="link" @click="otherLogin('linkedin')" />
        <img :src="google" @click="otherLogin('google')" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import vInput from '@/components/vInput'
import vCodes from '@/components/vCodes'
import TouristChat from '@/components/chat/TouristChat'
import { login, sendPhoneCode, checkEmail, validateMobile, checkBindExhibition } from '@/api/index'
import { reg } from '@/utils/function'
import { setToken } from '@/utils/auth'
import face from '@/assets/homeImages/face.png'
import link from '@/assets/homeImages/link.png'
import pin from '@/assets/homeImages/pin.png'
import google from '@/assets/homeImages/google.png'
import '@/vendor/platform.js'
import '@/vendor/facebookSDK.js'
import IN from '@/vendor/in.js'
// 是否只能注册
import statuConfig from '@/config/settings'

export default {
  name: 'loginComment',
  components: {
    vInput,
    vCodes,
    TouristChat
  },
  data() {
    return {
      dialogShow: false, // 提示框 - 改版记得删
      loginType: true,   //true:验证码登录  false：密码登录
      isPassLogin: false,
      inputVal: {
        phone: '',
        countryCode: '86',
        code: '',
        email: '',
        password: ''
      },
      face: face,
      link: link,
      pin: pin,
      google: google,
      FACEBOOK_CLIENT_ID: '289799448412151',
      GOOGLE_CLIENT_ID: '26838982656-522qe9r2sg716r22jhamhsjhei3dfsvg.apps.googleusercontent.com',
      LINKEDIN_CLIENT_ID: '81aumg4tej1foz',
      loading: false,
      externalAccountRequest: {
        platformType: '',
        platformUserId: '',
        name: '',
        picture: ''
      },
      loginStatus: false,
      // 用于检测展商的状态
      checkUserStatus: false
    }
  },
  computed: {
    ...mapGetters(['language', 'subjectType', 'invitationSource'])
  },
  mounted() {
    window.PC.$RangersEventLoginAndRegister('login_view')
    // this.isPassLogin = this.$store.getters.loginType === 'phone' ? false : true
    if (this.subjectType === 'VISITOR') {
      this.isPassLogin = this.language == 'en' ? true : false
    } else {
      this.isPassLogin = this.$store.getters.loginType === 'phone' ? false : true
    }
    this.$store.commit('SET_LOGIN_TYPE', this.isPassLogin == true ? 'email' : 'phone')
  },
  methods: {
    agreement() {
        window.PC.$RangersEventLoginAndRegister('privacy_policy')
        this.openNewPage("/agreement", true)
    },
    isPassLoginClick(status) {
        window.PC.$RangersEventLoginAndRegister('login_view')
        this.isPassLogin = status
        this.$store.commit('SET_LOGIN_TYPE', status ? 'email' : 'phone')
    },
    /**
     * 检测展商登录账号 是否存在
     */
    checkUser(account, fn) {
      let params = {}
      if (this.isPassLogin) {
        params.email = account
      } else {
        params.mobile = account
      }
      this.checkUserStatus = true
      checkBindExhibition(params)
        .then(res => {
          if (res.data && res.data.data) {
            this.actorLoginResult(res.data.data, res, fn)
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.checkUserStatus = false
          }, 500)
        })
    },
    /**
     * 展商身份
     * 密码登录时 账号输入框失去焦点时判断 账号是否存在
     * 验证码登录时 点击验证码时 判断账号是否存在
     */
    actorLoginCheck() {
      if (this.subjectType !== 'ACTOR') return
      let obj = this.inputVal
      // 邮箱登录
      if (this.isPassLogin) {
        if (!obj.email) {
          return false
        } else if (!reg.email.test(obj.email)) {
          this.$notify.error({
            message: this.$t('Please enter your correct email address'),
            type: 'err'
          })
          return false
        }
        this.checkUser(obj.email)
        return
      }
      let checkPhone = () => {
        if (!obj.phone) {
          return false
        } else if (!reg.chinesePhone.test(obj.phone)) {
          this.$notify.error({
            message: this.$t('Please enter your correct mobile'),
            type: 'err'
          })
          return false
        }
        return true
      }
      // 手机号 + 密码登录
      if (!this.loginType) {
        if (!checkPhone()) return
        this.checkUser(obj.phone)
        return
      }
    },
    goResetPass(path) {
      if (!path) {
        path = 'vResetPasswords'
      }
      window.PC.$RangersEventLoginAndRegister('forget_password', {status: this.isPassLogin})
      if (this.isPassLogin) {
        this.$store.commit('SET_LOGIN_ACCOUNT', this.inputVal.email) //记录下账号
      } else {
        this.$store.commit('SET_LOGIN_ACCOUNT', this.inputVal.phone) //记录下账号
      }
      this.$emit('callback', { type: 'switchComponents', path: path })
    },
    // 登录
    regLoginMess() {
      if (statuConfig.onlayReg && !statuConfig.onlayReg2 && this.subjectType == 'VISITOR') {
        this.noVisitorTodoAction()
        return
      }
      if (this.subjectType === 'ACTOR' && this.checkUserStatus) return
      var _this = this
      var obj = _this.inputVal
      var param = {}
      if (_this.isPassLogin) {
        //邮箱登录
        if (!obj.email) {
          _this.$notify.error({
            message: _this.$t('Please enter your email'),
            type: 'err'
          })
          return false
        } else if (!reg.email.test(obj.email)) {
          _this.$notify.error({
            message: _this.$t('Please enter your correct email address'),
            type: 'err'
          })
          return false
        } else if (!obj.password) {
          _this.$notify.error({
            message: _this.$t('Please enter your password'),
            type: 'err'
          })
          return false
        }
        param = {
          email: obj.email,
          password: _this.$md5(obj.password)
        }
        _this.$store.commit('SET_LOGIN_ACCOUNT', obj.email) //记录下账号
        _this.submit(param)
      } else {
        // 手机号登录
        if (!obj.phone) {
          _this.$notify.error({
            message: _this.$t('Please enter your moblie'),
            type: 'err'
          })
          return false
        } else if (!reg.chinesePhone.test(obj.phone)) {
          _this.$notify.error({
            message: _this.$t('Please enter your correct mobile'),
            type: 'err'
          })
          return false
        }
        if (this.loginType) {
            if (!obj.code) {
                _this.$notify.error({
                    message: _this.$t('Please enter your verification code'),
                    type: 'err'
                })
                return false
            }
        } else {
            if (!obj.password) {
                _this.$notify.error({
                    message: _this.$t('Please enter your password'),
                    type: 'err'
                })
                return false
            }
        }
        
        param = {
            mobile: obj.phone
        }
        if (this.loginType) {
            param.smsCode = obj.code
        } else {
            param.password = _this.$md5(obj.password)
        }
        param.countryCode = obj.countryCode
        _this.$store.commit('SET_LOGIN_ACCOUNT', obj.phone) //记录下账号
        _this.submit(param)
      }
    },
    // 提交登录
    async submit(params) {
        const account = this.isPassLogin ? this.inputVal.email : this.inputVal.phone
        window.PC.$RangersEventLoginAndRegister('signin', { status: this.isPassLogin, account })
        params.subjectType = this.subjectType
        if (params.subjectType == 'ACTOR') {
            // 展商登录逻辑
            this.loginStatus = true
            await login(params).then(async (res) => {
                if (res.data && res.data.data) {
                    await this.actorLoginResult(res.data.data, res)
                }
            }).finally(() => {
                this.loginStatus = false
            })
            return false
        }

        // let resultFn = (res, status) => {
        //     if (res.data && res.data.repeat) {
        //         // 已注册的
        //         this.visitorLogin(params)
        //     } else {
        //         let tipData = status ? this.$t('login2s.notAccount') : this.$t('login2s.notAccount2')
        //         // 未注册
        //         this.$confirm(tipData, this.$t('common.productTipsTitle'), {
        //             type: 'warning'
        //         }).then(() => {
        //             this.registerEvent()
        //         })
        //     }
        // }

        // 客商登录的逻辑
        // if (this.isPassLogin) {
        //     // 邮箱 查重
        //     checkEmail({
        //         email: this.inputVal.email
        //     }).then(res => {
        //         return res.data
        //     }).then(res => {
        //         resultFn(res, true)
        //     })
        // } else {
        //     // 手机号 查重
        //     validateMobile({
        //         mobile: this.inputVal.phone
        //     }).then(res => {
        //         return res.data
        //     }).then(res => {
        //         resultFn(res, false)
        //     })
        // }

        this.visitorLogin(params)
    },
    /**
     * 展商登录结果判断
     */
    async actorLoginResult(data, res, fn) {
      let result = false
      if (data.requiredBindExhibitor) {
        // 需要绑定展商
        setToken(res.headers.authorization)
        this.$notify({
          title: this.$t('Confirm'),
          message: this.$t('contactPerson'),
          type: 'warning'
        })
        //this.goResetPass('vExhibitorResetPassOrBindCode')
        result = true
      } else if (data.requiredSetPassword && !data.requiredVisitorRegister) {
        // 需要重置密码
        this.$notify({
          title: this.$t('Confirm'),
          message: this.$t('noPassword'),
          type: 'warning',
          duration: 3000
        })
        setTimeout(() => {
          setToken(res.headers.authorization)
          this.goResetPass('vResetPasswords')
        }, 2000)
        result = true
      } else if (data.requiredCompleteUserInfo) {
        await setToken(res.headers.authorization)
        // 设置登录成功后的信息
        await this.$store.dispatch('BaseInfo', data)
        await window.$TIM.logout().then(async () => {
          await this.$store.commit('toggleIsLogin')
          await this.$store.commit('reset')
        }).catch((err) => {
          console.log('err---->111--->', err)
        })
        await this.loginSuccess(this.subjectType)
        await this.$store.dispatch('getOnlineCustomer', this.$store.getters.isLogin)
        result = true
      } else if (res.headers.authorization) {
        // 登录成功 && 设置登录成功后的信息
        await setToken(res.headers.authorization)
        await this.$store.dispatch('BaseInfo', data)
        await window.$TIM.logout().then(async () => {
          await this.$store.commit('toggleIsLogin')
          await this.$store.commit('reset')
        }).catch((err) => {
          console.log('err---->222--->', err)
        })
        await this.loginSuccess(this.subjectType)
        await this.$store.dispatch('getOnlineCustomer', this.$store.getters.isLogin)
        result = true
      }
      console.log('没有符合条件的')
      if (result === true && this.codeAwait) {
        sessionStorage.setItem('codeAwait', '3')
        return
      }
      if (this.codeAwait) {
        sessionStorage.setItem('codeAwait', '2')
      }
      fn && fn()
    },
    /**
     * 客商登录
     */
    async visitorLogin(params) {
      this.loginStatus = true
      params.subjectType = this.subjectType
      params['externalAccountRequest'] = this.externalAccountRequest
      if (this.externalAccountRequest.name != '') {
        localStorage.setItem('rName', this.externalAccountRequest.name)
      }
      if (
        this.$funcs.getType(this.invitationSource) === 'object' &&
        this.invitationSource.exhibitorId &&
        this.invitationSource.exhibitorEmployeeUserAccountId
      ) {
        params.invitationRecord = this.invitationSource
        this.$store.commit('SET_INVITATION_SOURCE')
      }
      await login(params)
        .then(async (res) => {
          const data = res.data.data
          if (!data && res.headers.authorization) return
          if (data.requiredSetPassword) {
            // 重置密码
            this.$confirm(this.$t('setPassWord'), this.$t('tips'), {
              confirmButtonText: this.$t('ok'),
              cancelButtonText: this.$t('cancel'),
              type: 'warning'
            }).then(() => {
                setToken(res.headers.authorization)
                this.goResetPass('vResetPasswords')
              }).catch(() => {})
          }
          // else if (!data.requiredSetPassword && data.requiredVisitorRegister) {
          //   // 完善个人信息
          //   await setToken(res.headers.authorization)
          //   // 保存个人信息-防止返回数据丢失
          //   await this.$store.dispatch('BaseInfo', data)
          //   await this.loginSuccess(params.subjectType, null, this.isPassLogin, this.inputVal)
          // } else if (!data.requiredSetPassword && !data.requiredVisitorRegister) {
          //   // 去判断是否完成预登记 来进行操作
          //   await setToken(res.headers.authorization)
          //   await this.$store.dispatch('BaseInfo', data)
          //   await this.loginSuccess(params.subjectType)
          // }

          await setToken(res.headers.authorization)
          await this.$store.dispatch('BaseInfo', data)

          this.$store.commit('SET_LOGIN_ACCOUNT', data.currentLogonAccount)

          console.log(this.$store)
          // 如果有保存的访问地址，就跳转过去
          var href = window.sessionStorage.getItem('toPath')
          if (href) {
            sessionStorage.removeItem('toPath')
            this.$router.replace({ path: href })
          } else {
            this.$router.replace({ path: '/' })
          }
        })
        .finally(() => {
          this.loginStatus = false
        })
    },
    callback(res, status) {
      if (res.type !== 'sendCode') return
      window.PC.$RangersEventLoginAndRegister('sendCode', {
        account: this.inputVal.phone
      })
      let _this = this
      let sendPhoneFn = () => {
        sendPhoneCode({
          mobile: _this.inputVal.phone
        }).then(res => {
          if (res.data.code == 1000) {
            setToken(res.headers.authorization)
            _this.$notify({
              title: _this.$t('tip.success'),
              message: _this.$t('The verification code has been sent'),
              type: 'success'
            })
          }
        })
      }
      if (_this.subjectType === 'ACTOR' && status === true) {
        // 设置 触发前 是否触发 发送验证码
        sessionStorage.setItem('codeAwait', '1')
        this.codeAwait = true
        this.checkUser(_this.inputVal.phone, sendPhoneFn)
        return false
      } else {
        sessionStorage.removeItem('codeAwait')
        this.codeAwait = false
      }
      sendPhoneFn()
    },
    initStorage() {
      //初始化 -storage数据
      this.$store.commit('SET_LOGIN_ACCOUNT', '')
    },
    // 注册
    registerEvent() {
      window.PC.$RangersEventLoginAndRegister('register', {status: this.isPassLogin})
      this.$tracking('010201')
      if (this.isPassLogin) {
        // 邮箱注册
        this.$store.commit('SET_LOGIN_ACCOUNT', this.inputVal.email)
        this.$router.push({ path: '/register/email/1' })
      } else {
        // 手机号注册
        this.$store.commit('SET_LOGIN_ACCOUNT', this.inputVal.phone)
        // this.$router.push({path: '/l-register/mobile'})
        this.$router.push({ path: '/register/mobile/0' })
      }
    },
    initGoogle(opts = {}) {
      let baseOptions = {
        client_id: this.GOOGLE_CLIENT_ID,
        cookiepolicy: 'single_host_origin'
      }
      let options = { ...baseOptions, ...opts }
      window.gapi.load('auth2', function() {
        window.gapi.auth2.init(options).then(
          res => {
            console.log('init success:', res)
          },
          err => {
            console.log('init error:', err)
          }
        )
      })
    },
    googleSignIn() {
      var _this = this
      this.loading = true
      try {
      window.gapi.auth2
        .getAuthInstance()
        .signIn()
        .then(
          function(res) {
            console.log('login success:', res)
            _this.externalAccountRequest.platformUserId = res['Da']
            _this.externalAccountRequest.platformType = 'google'
            _this.externalAccountRequest.name = res['tt']['Ad']
            _this.externalAccountRequest.picture = res['tt']['jK']
            _this.$store.commit('SET_LOGIN_ACCOUNT', res['tt']['bu'])
            _this.visitorLogin({})
          },
          function(err) {
            _this.loading = false
            console.log('login error:', err)
          }
        )
      } catch(e) {
          _this.loading = false
          console.log(e)
      }
    },
    loginIn() {
      IN.login(this.LINKEDIN_CLIENT_ID)
    },
    watchIn() {
      var _this = this
      IN.watchIN(function() {
        var code = _this.$route.query.code
        IN.getMeInfo(code, _this.inLoginSuccess(), _this.inLoginError())
      }, _this.inLoginError())
    },
    inLoginSuccess() {
      var _this = this
      return function(res) {
        _this.loading = true
        var data = res.data['data']['data']
        var inData = JSON.parse(data)
        if (!inData['firstName']) {
          _this.loading = false
          return
        }
        if (!data) {
          return
        }
        console.log('IN Login Success：', inData)
        _this.externalAccountRequest.platformUserId = inData['id']
        _this.externalAccountRequest.platformType = 'linkedin'
        _this.externalAccountRequest.name = inData['localizedLastName'] + inData['localizedFirstName']
        if (inData['profilePicture']) {
          var displayImage = inData['profilePicture']['displayImage~']
          _this.externalAccountRequest.picture = displayImage['elements'][0]['identifiers'][0]['identifier']
        }
        _this.visitorLogin({})
      }
    },
    inLoginError() {
      return function(res) {
        console.log('IN Login Error', res)
      }
    },
    initFaceBook() {
      try {
        window.FB.init({
          appId: this.FACEBOOK_CLIENT_ID,
          cookie: true,
          version: 'v2.9'
        })
      } catch (e) {
        console.log(e)
      }
    },
    loginFB() {
      var _this = this
      window.FB.login(
        function(response) {
          _this.loading = true
          if (response.status == 'connected') {
            _this.loading = false
            response.authResponse.accessToken
          }
          window.FB.api('/me', function(res) {
            console.log('FaceBook UserInfo:', res)
            _this.loading = false
            _this.externalAccountRequest.platformUserId = res.id
            _this.externalAccountRequest.platformType = 'facebook'
            _this.externalAccountRequest.name = res.name
            _this.externalAccountRequest.picture = ''
            _this.visitorLogin({})
          })
        },
        { scope: 'public_profile,email' }
      ) //需要获取的信息scope
    },
    otherLogin(type) {
      window.PC.$RangersEventLoginAndRegister(type)
      switch (type) {
        case 'facebook':
          this.loginFB()
          break
        case 'linkedin':
          this.loginIn()
          break
        case 'google':
          this.googleSignIn()
          break
        default:
          break
      }
    }
  },
  created() {
    if (localStorage.getItem('loginType') == 'phone' && this.subjectType == 'ACTOR') {
      this.isPassLogin = false
    } else {
      this.isPassLogin = true
    }
    this.initStorage()
    if (this.$config.settings.thirdPartyLogin && this.subjectType == 'VISITOR') {
      try {
        this.initFaceBook()
        this.initGoogle()
        this.watchIn()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.text_regi {
  margin-left: 3px;
  color: $color-main;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.no-account2 {
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
  color: $color-black-65;
}

.v-login-flex {
  line-height 14px
  display flex
  justify-content:space-between
}
</style>
